import { Alert } from "components/alert/Alert";
import { Icon } from "components/icon/Icon";
type Props = {
  isInvalid: boolean;
};

export default function ContentSizeAlert({ isInvalid }: Props) {
  if (!isInvalid) {
    return null;
  }

  return (
    <Alert className="mt-2" variant="warning" onDismiss={undefined}>
      <Icon name="exclamation-circle" className="mr-2" />
      <span>
        Innehållet som du har lagt till i meddelandet är för stort (maxstorlek
        är 4 MB). Ta bort medieinnehållet från texten och bifoga det som en fil
        i stället.
      </span>
    </Alert>
  );
}
